export const getApiUrl = () => {
  if (process.env.NODE_ENV && process.env.NODE_ENV === "development") {
    return "http://localhost:3001";
  } else {
    return `https://api.${process.env.NEXT_PUBLIC_API_URL}`;
  }
};

export const getDirectusUrl = () => {
  if (process.env.NODE_ENV && process.env.NODE_ENV === "development") {
    return "http://localhost:8055";
  } else {
    return "http://cms:8055";
  }
};

export const getAssetsUrl = () => {
  if (process.env.NODE_ENV && process.env.NODE_ENV === "development") {
    return "http://localhost:8055/assets";
  } else {
    // this works thanks to nginx
    return "https://chatsystem.ai/cms/assets";
  }
};
